import "./BasicDetailsController.scss"
import { InputTextarea } from 'primereact/inputtextarea'
import { classNames } from 'primereact/utils'
import React from 'react'
import { Controller } from 'react-hook-form'
import InputText from '../../../../components/prime-react-overrides/input-text/InputText'
import Dropdown from "../../../../components/prime-react-overrides/dropdown/Dropdown"
import { ReactComponent as InputFieldErrorIcon } from '../../assets/InputFieldErrorIcon.svg'

const ToDisplayComp = ({ field, fieldState, isTextArea, isDropdown, fieldKey, fieldName, errors, className = 'capitalize', ...restProps }) => {
    if (isTextArea) {
        return (
            <div className='FieldContainer relative'>
                <InputTextarea id={fieldKey} {...field} {...restProps} className={classNames("text-sm font-medium", { 'p-invalid': fieldState.invalid, Active: field.value }, 'w-full')}
                />
                <label htmlFor="" className={classNames("Label pointer-events-none absolute  font-semibold", { 'p-error': errors[fieldKey], Active: field.value })}>
                    {fieldName}
                </label>
            </div>
        )
    }
    else if (isDropdown) {
        return (
            <div className='FieldContainer relative'>
                <Dropdown id={fieldKey} {...field} {...restProps} className={classNames("text-sm font-medium", { 'p-invalid': fieldState.invalid, Active: field.value }, 'w-full', className)}
                />
                <label htmlFor="" className={classNames("Label pointer-events-none absolute  font-semibold", { 'p-error': errors[fieldKey], Active: field.value })}>
                    {fieldName}
                </label>
            </div>

        )
    }
    else {
        return (
            <div className='FieldContainer relative'>
                <InputText  id={fieldKey} {...field} {...restProps} className={classNames("text-sm font-medium", { 'p-invalid': fieldState.invalid, Active: field.value }, 'w-full', className)}

                />
                <label htmlFor="" className={classNames("Label pointer-events-none absolute  font-semibold", { 'p-error': errors[fieldKey], Active: field.value })}>
                    {fieldName}
                </label>
            </div>
        )
    }
}

const BasicDetailsController = ({ errors, fieldKey, fieldName, control, isTextArea = false, className = 'capitalize', ...restProps }) => {

    return (
        <div className="BasicDetailsController flex flex-column">
            <Controller name={fieldKey} control={control} render={({ field, fieldState }) => (
                <ToDisplayComp field={field} fieldState={fieldState} isTextArea={isTextArea} fieldKey={fieldKey} fieldName={fieldName} errors={errors} className={className}  {...restProps} />
            )} />
            {errors[fieldKey] && <small className='p-error font-medium my-1 flex align-items-center ' ><InputFieldErrorIcon /> {errors[fieldKey].message}</small>}
        </div>
    )
}

export default BasicDetailsController